<div class="card h-100">
  <div class="card-header no-border">
    <div class="d-flex justify-content-center">
      <sb-search-bar placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                     searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                     stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"
                     (searchAction)="doSearch($event)"
                     headline="{{ 'lang.headlines.motiveGroups' | translate }}" [showExactMatch]="true"
                     [subline]="paginationString" [searchStr]="search">
      </sb-search-bar>
    </div>
    <div class="header-more">
      <div class="d-flex align-items-center">
        <!--
        <a #Arrangement orderOption="Arrangement" (click)="setToOrder($event, Arrangement)">
          <sb-button classes="btn-hover-primary">
            <sb-icon class="icon-in-btn"
                     *ngIf="!(selectedOrderOption?.caption===Arrangement.attributes.getNamedItem('orderOption').value)"
                     icon="arrowsExchangeVAlt"></sb-icon>
          </sb-button>
        </a>
        -->
        <ng-container *ngPermissions="permissionService.Permission.medium_group_list">
          <button class="btn btn-hover-primary" [ngClass]="getFilterSelectClass()" [disabled]="true">
            <sb-icon icon="company"></sb-icon>
            {{ getFilterText() }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="card-fit">
    <table class="table">
      <thead>
      <tr>
        <th class="table--sortable" (click)="setToOrder('Title')"
            [ngClass]="{'table--sorted': orderOption?.value==='Title'}">
          {{ 'lang.globals.name' | translate }}
          @if (orderOption.value === 'Title') {
            <sb-icon
              *ngIf="orderOption.direction === 'desc'"
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
            <sb-icon
              *ngIf="orderOption.direction !== 'desc'"
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon
              icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </th>
        <th *ngIf="!selectedCompany">
          {{ 'lang.globals.companies' | translate }}
        </th>
        <th>

        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let mediumGroup of mediumGroups">
        <td>
          <sb-comp-image-name-wrapper [medium]="mediumGroup?.preview" [background]="true" [hoverPreview]="true">
            <span firstLine [innerHTML]="mediumGroup?.name | truncate : 30"></span>
            <span secondLine [innerHTML]="mediumGroup?.description|truncate:25"> </span>
            <span
              thirdLine>{{ mediumGroup?.mediaCount }} {{ mediumGroup?.mediaCount === 1 ? ('lang.globals.motive'|translate) : ('lang.globals.motives'|translate) }}</span>
            <sb-tags
              fourthLine
              [dtoId]="mediumGroup.id"
              [tags]="mediumGroup.tags"
              *ngPermissions="[permissionService.Permission.tag_list]"
              [dtoType]="tagService.TaggableDTO.MediumGroup">
            </sb-tags>
          </sb-comp-image-name-wrapper>
        </td>
        <td *ngIf="!selectedCompany">
          <span [innerHTML]="mediumGroup?.company?.name |truncate:15"> </span>
          <!--- {{mediumGroup?.company?.id}} --->
        </td>
        <td class="text-end">
          <div [attr.data-groupId]="mediumGroup.id"
               [attr.data-companyId]="mediumGroup?.company?.id"
               class="btn btn-hover-primary dragMePlz">
            <sb-icon icon="drag"></sb-icon>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="card-footer">
    <div sb-pagination *ngIf="paginationInitialized" [collectionSize]="collectionSize" [(page)]="page"
         (pageChange)="pageChange($event)" [maxSize]="maxSize" [showPageSize]="false" [showGotoPage]="false"
         [showPageCount]="false" [boundaryLinks]="boundaryLinks" (pageSizeChange)="setMaxSize($event)">
    </div>
  </div>
</div>
